import {Module} from "../index";
import {YouthPlayer, YouthPlayerNegotiation} from "./entity";
import YouthPlayerFactory from "./services/factories/YouthPlayerFactory";
import {YouthPlayerSeederEventSubscriber} from "./subscribers/YouthPlayerSeederEventSubscriber";
import {RegionScoutingEvaluator} from "./services/evaluators/RegionScoutingEvaluator";
import {YouthPlayerScoutingEvaluator} from "./services/evaluators/YouthPlayerScoutingEvaluator";
import {LinkComponentManager} from "@/modules/vue/services/LinkComponentManager";
import YouthPlayerLink from "./components/YouthPlayerLink.vue";
import {YouthPlayerNegotiationStarter} from "./services/YouthPlayerNegotiationStarter";
import {NegotiationComponentManager} from "@/modules/diplomacy/services/NegotiationComponentManager";
import YouthPlayerNegotiationComponent from "./components/YouthPlayerNegotiation.vue";
import {YouthPlayerNegotiationCloser} from "@/modules/youth/services/YouthPlayerNegotiationCloser";
import {NegotiationCloserInterface} from "@/modules/diplomacy/interfaces";
import {TYPES} from "@/modules/diplomacy/types";
import {RecruitYouthPlayerEventSubscriber} from "@/modules/youth/subscribers/RecruitYouthPlayerEventSubscriber";
import {Recruiter} from "@/modules/youth/services/Recruiter";
import NotificationCreator from "@/modules/youth/notifications/NotificationCreator";
import {NotificationFactory} from "@/modules/youth/factories/NotificationFactory";
import {SeederEventSubscriber} from "@/modules/youth/subscribers/SeederEventSubscriber";
import {ScoutingCompletedNotification} from "@/modules/youth/entity/ScoutingCompletedNotification";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import {ActionScreensEventSubscriber} from "@/modules/youth/subscribers/ActionScreensEventSubscriber";
import {SeasonEvaluationEventSubscriber} from "@/modules/youth/subscribers/SeasonEvaluationEventSubscriber";
import NewcomerYouthPlayerFactory from "@/modules/youth/services/factories/NewcomerYouthPlayerFactory";
import {NewcomerRecruiter} from "@/modules/youth/services/NewcomerRecruiter";
import {YouthPlayerTransferator} from "@/modules/youth/services/YouthPlayerTransferator";
import YouthPlayerWageCalculator from "@/modules/youth/services/YouthPlayerWageCalculator";
import {SeasonModule} from "@/modules/season";

export class YouthModule extends Module {
  messages = messages;
  routes = routes;

  dependsOn = [
    SeasonModule,
  ];

  eventSubscribers = [
    YouthPlayerSeederEventSubscriber,
    RecruitYouthPlayerEventSubscriber,
    SeederEventSubscriber,
    ActionScreensEventSubscriber,
    SeasonEvaluationEventSubscriber,
  ];

  public entities = [
    YouthPlayer,
    YouthPlayerNegotiation,
    ScoutingCompletedNotification,
  ];

  protected register() {
    super.register();

    this.app.bind<YouthPlayerFactory>(YouthPlayerFactory).to(YouthPlayerFactory);
    this.app.bind<NewcomerYouthPlayerFactory>(NewcomerYouthPlayerFactory).to(NewcomerYouthPlayerFactory);

    this.app.bind<RegionScoutingEvaluator>(RegionScoutingEvaluator).to(RegionScoutingEvaluator);
    this.app.bind<YouthPlayerScoutingEvaluator>(YouthPlayerScoutingEvaluator).to(YouthPlayerScoutingEvaluator);
    this.app.bind<YouthPlayerNegotiationStarter>(YouthPlayerNegotiationStarter).to(YouthPlayerNegotiationStarter);
    this.app.bind<Recruiter>(Recruiter).to(Recruiter);
    this.app.bind<NewcomerRecruiter>(NewcomerRecruiter).to(NewcomerRecruiter);
    this.app.bind<YouthPlayerTransferator>(YouthPlayerTransferator).to(YouthPlayerTransferator);
    this.app.bind<YouthPlayerWageCalculator>(YouthPlayerWageCalculator).to(YouthPlayerWageCalculator);

    this.app.bind<NotificationCreator>(NotificationCreator).to(NotificationCreator);
    this.app.bind<NotificationFactory>(NotificationFactory).to(NotificationFactory);

    this.app.bind<NegotiationCloserInterface>(TYPES.NegotiationCloser).to(YouthPlayerNegotiationCloser);
  }

  boot() {
    super.boot();

    this.app.get(NegotiationComponentManager).addItem({
      class: YouthPlayerNegotiation,
      component: YouthPlayerNegotiationComponent,
    });

    this.app.get(LinkComponentManager).addItem({
      class: YouthPlayer,
      component: YouthPlayerLink,
    });
  }
}
